import { render, staticRenderFns } from "./DMCR.vue?vue&type=template&id=edf67764&"
import script from "./DMCR.vue?vue&type=script&lang=js&"
export * from "./DMCR.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports